import React from 'react';
import { Box, Typography, Container, Grid, Paper } from '@mui/material';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import { motion } from 'framer-motion';

const About = () => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();

  return (
    <Box
      id="about"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: theme => 
          isDarkMode 
            ? 'rgba(18, 18, 18, 0.8)' 
            : 'rgba(245, 247, 250, 0.8)',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
            >
              <Box
                component="img"
                src="/about-logo.png"
                alt="ITFORSEC - One team. Infinite tech solutions."
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: 4,
                  boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                  transition: 'transform 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.02)',
                  }
                }}
              />
            </motion.div>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
            >
              <Typography
                variant="h2"
                component="h2"
                gutterBottom
                sx={{
                  fontWeight: 700,
                  mb: 4,
                  background: 'linear-gradient(45deg, #2E5BFF, #00C896)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                {t('aboutTitle')}
              </Typography>
              
              <Typography
                variant="body1"
                sx={{
                  mb: 4,
                  fontSize: '1.1rem',
                  lineHeight: 1.8,
                  color: theme => isDarkMode ? theme.palette.text.secondary : theme.palette.text.primary,
                }}
              >
                {t('aboutContent')}
              </Typography>
              
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 4 }}>
                <Paper
                  elevation={1}
                  sx={{
                    py: 1,
                    px: 3,
                    borderRadius: 4,
                    backgroundColor: isDarkMode ? 'rgba(46, 91, 255, 0.1)' : 'rgba(46, 91, 255, 0.05)',
                    border: '1px solid',
                    borderColor: isDarkMode ? 'rgba(46, 91, 255, 0.3)' : 'rgba(46, 91, 255, 0.2)',
                  }}
                >
                  <Typography variant="body2" fontWeight={500}>
                    IT Security
                  </Typography>
                </Paper>
                
                <Paper
                  elevation={1}
                  sx={{
                    py: 1,
                    px: 3,
                    borderRadius: 4,
                    backgroundColor: isDarkMode ? 'rgba(0, 200, 150, 0.1)' : 'rgba(0, 200, 150, 0.05)',
                    border: '1px solid',
                    borderColor: isDarkMode ? 'rgba(0, 200, 150, 0.3)' : 'rgba(0, 200, 150, 0.2)',
                  }}
                >
                  <Typography variant="body2" fontWeight={500}>
                    Software Development
                  </Typography>
                </Paper>

                  <Paper
                  elevation={1}
                  sx={{
                    py: 1,
                    px: 3,
                    borderRadius: 4,
                    backgroundColor: isDarkMode ? 'rgba(0, 200, 150, 0.1)' : 'rgba(0, 200, 150, 0.05)',
                    border: '1px solid',
                    borderColor: isDarkMode ? 'rgba(0, 200, 150, 0.3)' : 'rgba(0, 200, 150, 0.2)',
                  }}
                >
                  <Typography variant="body2" fontWeight={500}>
                    Mobile App Development
                  </Typography>
                </Paper>
                
                <Paper
                  elevation={1}
                  sx={{
                    py: 1,
                    px: 3,
                    borderRadius: 4,
                    backgroundColor: isDarkMode ? 'rgba(255, 107, 107, 0.1)' : 'rgba(255, 107, 107, 0.05)',
                    border: '1px solid',
                    borderColor: isDarkMode ? 'rgba(255, 107, 107, 0.3)' : 'rgba(255, 107, 107, 0.2)',
                  }}
                >
                  <Typography variant="body2" fontWeight={500}>
                    Web3 Solutions
                  </Typography>
                </Paper>
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;
